import React from 'react';

// Mirrors resources/views/components/promo-header.blade.php in the
// tailwindcomponents repo. Replaces the old single Creative Tim UI image.

interface PromoCard {
  slug: string;
  title: string;
  description: string;
  image: string;
  link: string;
}

const CARDS: PromoCard[] = [
  {
    slug: 'app-builder',
    title: 'AI App Builder',
    description: 'Describe your idea and Creative Tim AI ships a real, deployed app in minutes.',
    image: 'https://raw.githubusercontent.com/creativetimofficial/public-assets/refs/heads/master/creative-tim/app-builder-ct-thumb.jpg',
    link: 'https://www.creative-tim.com/ui/build',
  },
  {
    slug: 'openclaw',
    title: 'OpenClaw AI Agent',
    description: '1-click deploy your personal AI assistant with integrations, code execution and Claude models.',
    image: 'https://raw.githubusercontent.com/creativetimofficial/public-assets/refs/heads/master/creative-tim/agents-dashboard-thumb.jpg',
    link: 'https://www.creative-tim.com/ui/openclaw',
  },
  {
    slug: 'hermes',
    title: 'Hermes Agent',
    description: 'Deploy a persistent, autonomous AI agent with built-in memory, tools and skills.',
    image: 'https://raw.githubusercontent.com/creativetimofficial/public-assets/refs/heads/master/creative-tim/hermes-agent-thumb.jpg',
    link: 'https://www.creative-tim.com/ui/hermes',
  },
  {
    slug: 'ai-video',
    title: 'AI Video Generator',
    description: 'Turn one product photo into a full content pack, images and a short video.',
    image: 'https://gtmkkedrbdengphuhcxs.supabase.co/storage/v1/object/public/ecomm-content/ecomm/4687/p8gu5U3aDJMD/image-1.jpg',
    link: 'https://www.creative-tim.com/ui/video/ecomm-usecase',
  },
];

const PromoCards: React.FC<{ refPrefix?: string }> = ({ refPrefix = 'twc-cheatsheet' }) => (
  <div className="max-w-6xl px-4 mx-auto mt-6">
    <div className="overflow-hidden bg-gradient-to-b from-gray-900 to-black rounded-2xl">
      <div className="px-5 py-6 sm:px-8 sm:py-8">
        <p className="text-sm text-center text-white/70 sm:text-base">
          AI Agents, AI Video Generators and the App Builder &mdash;{' '}
          <span className="font-semibold text-white">get full access from $29/month.</span>
        </p>

        <div className="grid gap-4 mt-6 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((card) => (
            <a
              key={card.slug}
              href={`${card.link}?ref=${refPrefix}-${card.slug}`}
              target="_blank"
              rel="noreferrer"
              className="flex flex-col overflow-hidden text-left transition-transform duration-200 border rounded-xl border-white/20 bg-white/10 hover:-translate-y-1 hover:bg-white/[0.18]"
            >
              <div className="overflow-hidden aspect-video bg-white/5">
                <img
                  src={card.image}
                  alt={card.title}
                  loading="lazy"
                  className="object-cover w-full h-full"
                />
              </div>
              <div className="px-4 pt-3 pb-4">
                <h3 className="text-base font-bold text-white">{card.title}</h3>
                <p className="mt-1.5 text-[13px] leading-snug text-white/80">{card.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default PromoCards;
